module.exports = __webpack_public_path__ + "img/awos-en.bc299af8.png";